import HorizontalCard from 'components/HorizontalCard';
import MainButton from 'components/MainButton';
import Layout from 'Layout'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { sendLaporan } from 'services/apiRoutes';
import ImLayanan from 'assets/images/ImLayanan.jpg'

export default function Layanan() {
  const {slug}=useParams()
  const [loading,setLoading]=useState(false);
  const navigate = useNavigate();
  const [nama,setNama]=useState();
  const [subject, setSubject] = useState();
  const [pesan, setPesan] = useState();
  const [message,setMessage]=useState();
  const[success,setSuccess]=useState(false);

   const onSubmit = async () => {
     const data = {
      nama,
      subject,
      pesan,
     };

     setLoading(true);
     const res = await sendLaporan(data,slug);
     if (res.error) {
       setLoading(false);
       setMessage(res.message)
       return res.message
     } else {
      setSuccess(true);
      setLoading(false)
      setTimeout(() => {
        navigate(0);
      }, 1000);
     }
   };

  return (
    <Layout>
      <div className="px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="text-2xl font-bold xl:mb-20 mb-14 xl:text-7xl">
          Layanan Masyarakat
        </h1>
        <div className="space-y-24 wrapperCad">
          <HorizontalCard
            // desc="90% Masyarakat Gampong Geulanggang teungoh adalah Petani"
            title="Layanan Masyarakat"
            img={ImLayanan}
          />
        </div>
        <div className="mt-[78px] font-bold text-sm">Nama anda</div>
        <div className="flex mt-4 space-y-3 searchWrapper mb-14">
          <input
            placeholder="Masukkan nama anda"
            onChange={(e) => setNama(e.target.value)}
            type="text"
            className="px-3 py-6 border seacrh rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none xl:w-[994px] mr-4 w-full"
          />
        </div>
        <div className="flex mt-[78px] items-center space-x-6 overflow-x-scroll xl:overflow-x-hidden">
          <div className="text-sm font-bold">Subjek</div>
          {/* <MainButton secondType label="Pembangunan" /> */}
          {/* <MainButton secondType label="Lomba" /> */}
          {/* <MainButton secondType label="Rapat" /> */}
        </div>
        <div className="flex mt-4 space-y-3 searchWrapper mb-14">
          <input
            placeholder="Masukkan subject"
            onChange={(e) => setSubject(e.target.value)}
            type="text"
            className="px-3 py-6 border seacrh rounded-2xl  focus:ring-2 focus:ring-primary focus:border-none focus:outline-none xl:w-[994px] mr-4 w-full"
          />
          
        </div>
        <div className="text-sm font-bold mt-9">Pesan anda</div>
        <textarea
          placeholder="Masukkan pesan"
          onChange={(e) => setPesan(e.target.value)}
          name="pesan"
          id="message"
          cols="30"
          rows="10"
          className="p-5 mt-3 xl:w-[994px] w-full mb-12 border rounded-2xl focus:ring-2 focus:ring-primary focus:border-none focus:outline-none"
        />
        {success && (
          <div
            className="px-6 py-5 mb-4 text-base text-green-700 bg-green-100 rounded-lg"
            role="alert"
          >
            Pesan Berhasil Terkirim!
          </div>
        )}
        {message && (
          <div
            className="px-6 py-5 mb-4 text-base text-red-700 bg-red-100 rounded-lg "
            role="alert"
          >
            {message}
          </div>
        )}
        <div className="mb-64 sendWrapper">
          <MainButton
            label="Kirim"
            loading={loading}
            onClick={onSubmit}
            // onSubmit={onSubmit}
          />
        </div>
      </div>
    </Layout>
  );
}
